export const GADGET_COLOR_TYPE = {
  /** 白 */
  WHITE: '#FFFFFF',
  /** グレー */
  GRAY: '#E6E6E6',
  /** オレンジ */
  ORANGE: '#FFE5E3',
  /** 紫 */
  PURPLE: '#F0E3FF',
  /** 青 */
  BLUE: '#E3F8FF',
  /** 緑 */
  GREEN: '#E7FFE3',
  /** ピンク */
  PINK: '#FFE3F6',
  /** 黄 */
  YELLOW: '#FFF4E3',
} as const;
